<template>
    <div>
        <app-sub-title text="Tipos de herramienta" />
        <button class="btn btn-primary" @click="startCreateType">
            <i class="fa fa-plus"></i> Crear tipo de herramienta
        </button>
        <app-item-types-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="startDeleteType"
            @sort="onSort"
        />

        <!-- PopUps -->
        <app-pop-up
            id="item-type-form"
            title="Formulario tipo de herramienta"
            :on-close="cleanForm"
        >
            <div slot="body">
                <app-item-type-form :my-type="itemType" @created="onCreated" @updated="onUpdated" />
            </div>
            <div slot="buttons">
                <button class="btn btn-primary" :disabled="inProgress" @click="saveTypeItem">
                    <i class="fa fa-save"></i> Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="item-type-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este tipo de herramienta?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteType(itemType)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import itemsRepository from '../../../repositories/items.repository'
import PopUp from '../../UI/Controls/PopUp/PopUp.vue'
import ItemTypeForm from './ItemTypeForm/ItemTypeForm.vue'
import SubTitle from '../../UI/Layout/SubTitle.vue'
import ItemTypesList from './ItemTypesList/ItemTypesList.vue'

export default {
    components: {
        appPopUp: PopUp,
        appItemTypeForm: ItemTypeForm,
        appSubTitle: SubTitle,
        appItemTypesList: ItemTypesList,
    },

    data() {
        return {
            data: [],
            page: 1,
            itemType: '',
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
        }
    },
    methods: {
        async loadtypes() {
            try {
                const params = {
                    page: this.page,
                    sortBy: this.sort.sortBy,
                    sortDir: this.sort.sortDir,
                    with: 'fields'
                }
                const { data } = await repo.get('item-types', params)
                this.data = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        onChangePage(page) {
            this.page = page
            this.loadtypes()
        },
        onEdit(type) {
            this.itemType = Object.assign({}, type)
            this.$bus.$emit('item-type-form.open')
        },
        async deleteType(type) {
            const { data } = await repo.delete(`item-types/${type.id}`)
            if (!!data.status) {
                this.loadtypes()
                this.$bus.$emit('item-type-remove.close')
                toastr.success(data.msg)
            } else {
                toastr.error(
                    'Ocurrió un error al eliminar el tipo de herramienta'
                )
            }
        },
        startDeleteType(itemType) {
            this.itemType = itemType
            this.$bus.$emit('item-type-remove.open')
        },
        startCreateType() {
            this.itemType = ''
            this.$bus.$emit('item-type-form.open')
        },
        saveTypeItem() {
            this.$bus.$emit('item-type-form.save')
        },
        onCreated() {
            this.$bus.$emit('item-type-form.close')
            this.loadtypes()
        },
        cleanForm() {
            this.$bus.$emit('item-type-form.clean')
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadtypes()
        },
        onUpdated(data) {
            this.$bus.$emit('item-type-form.close')
            this.loadtypes()
            toastr.success(data.msg)
        },
    },

    created() {
        this.loadtypes()
    },
}
</script>
